export interface IMenu {
    title: string,
    url: string,
    titleEn: string,
    subMenu?: {
        title: string
        url: string
    }[],
    subMenuOpen?: boolean,
}

export const menu: IMenu[] = [
    {
        title: '견적요청', url: '', titleEn: 'quote',
        subMenu: [
            { title: '간편 견적요청', url: '/quote/simple/create' },
            { title: '상세 견적요청', url: '/quote/normal/create' },
            { title: '견적현황', url: '/quote/status/list' },
        ],
        subMenuOpen: false,
    },
    {
        title: '진행현황',
        titleEn: 'transport',
        url: '/transport/list'
    },
    {
        title: '특가운임',
        titleEn: 'special',
        url: '/special/list'
    },
    {
        title: '물류뉴스',
        titleEn: 'news',
        url: '/news/list',
    },
    // {
    //     title: '솔로몬쉽',
    //     titleEn: 'solomonShip',
    //     url: '/solomonShip',
    // },
]

export const profileMenu = [
    {
        title: '회원정보 관리',
        url: '/mypage'
    },
    {
        title: '회사정보 관리',
        url: '/company'
    },
    {
        title: '알림내역',
        url: 'noti'
    },
    {
        title: '이슈내역',
        url: '/issue/blList'
    },
    {
        title: '로그아웃',
        url: 'logout'
    },
] 